<script setup lang="ts">
import { onMounted } from 'vue'
import { ensureAuthHooks } from './stores/auth'

onMounted(() => {
  ensureAuthHooks()
})
</script>

<template>
  <RouterView />
</template>
